import { Cell } from './Cell'
import { solution, unicodeSplit } from '../../lib/words'
import { SUPP_WIDTH } from '../../constants/settings'

type Props = {
  guess: string
  className: string
}

export const CurrentRow = ({ guess, className }: Props) => {
  const splitGuess = unicodeSplit(guess)
  const emptyCells = Array.from(Array(solution.length - splitGuess.length))
  const classes = `flex justify-center mb-1 ${className}`

  return (
    <div className={classes}>
      {splitGuess.map((letter, i) => (
        <Cell key={i} value={letter} />
      ))}
      {emptyCells.map((_, i) => (
        <Cell key={i} />
      ))}
    <span style={{maxWidth: SUPP_WIDTH, width: SUPP_WIDTH}}>&nbsp;</span>
    </div>
  )
}
